import { AvvocatoList } from './../types/index';
import axios from 'axios';
import { Avvocato, IdVersion, AvvocatoCreateCommand, AvvocatoUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/avvocati';

export const getByKey = async (id: number): Promise<Avvocato> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<AvvocatoList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: AvvocatoCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: AvvocatoUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

